/**
 * Product Quiz — "Help Me Choose"
 * Prishious Jewellery Store
 *
 * Data-driven quiz — reads config from #pqConfig JSON output by quiz-banner.liquid.
 * All questions, options, and mappings are editable from Shopify Theme Editor.
 */

(function () {
  'use strict';

  /* ── Default Config (fallback if no #pqConfig found) ── */
  var DEFAULT_CONFIG = {
    quizTitle: 'Find Your Perfect Piece',
    quizSubtitle: "Answer a few quick questions & we'll guide you",
    resultMessageSelf: "We've found the perfect picks just for you!",
    resultMessageGift: "Here are some stunning gift-worthy pieces they'll love!",
    steps: [
      {
        question: 'Who are you shopping for?',
        options: [
          { emoji: '💁‍♀️', label: 'Myself', value: 'self' },
          { emoji: '🎁', label: 'A Gift', value: 'gift' }
        ]
      },
      {
        question: 'What type of jewellery?',
        options: [
          { emoji: '📿', label: 'Necklaces', collection: 'necklaces', collectionTitle: 'Necklaces', resultEmoji: '📿' },
          { emoji: '✨', label: 'Earrings', collection: 'earrings', collectionTitle: 'Earrings', resultEmoji: '✨' },
          { emoji: '💍', label: 'Rings', collection: 'rings', collectionTitle: 'Rings', resultEmoji: '💍' },
          { emoji: '🎲', label: 'Surprise Me', collection: 'all', collectionTitle: 'All Jewellery', resultEmoji: '💎' }
        ]
      },
      {
        question: "What's your style vibe?",
        threeCol: true,
        options: [
          { emoji: '🤍', label: 'Minimal & Dainty', tag: 'minimal' },
          { emoji: '🖤', label: 'Bold & Statement', tag: 'bold' },
          { emoji: '💜', label: 'Trendy & Fun', tag: 'trendy' }
        ]
      },
      {
        question: "What's your budget?",
        threeCol: true,
        options: [
          { emoji: '💰', label: 'Under ₹499', sort: 'price-ascending' },
          { emoji: '💎', label: '₹499 – ₹999', sort: 'none' },
          { emoji: '👑', label: '₹1000+', sort: 'price-descending' }
        ]
      }
    ]
  };

  /* ── Load Config ── */
  function loadConfig() {
    var configEl = document.getElementById('pqConfig');
    if (!configEl) return DEFAULT_CONFIG;

    try {
      var raw = JSON.parse(configEl.textContent);

      /* Clean null entries from Liquid trailing commas */
      if (raw.steps) {
        raw.steps.forEach(function (step) {
          if (step.options) {
            step.options = step.options.filter(function (o) { return o !== null; });
          }
        });
      }

      return raw;
    } catch (e) {
      console.warn('Quiz: Could not parse config, using defaults.', e);
      return DEFAULT_CONFIG;
    }
  }

  /* ── State ── */
  var config;
  var currentStep = 0;
  var answers = {};
  var selectedOptions = {};

  /* ── DOM References ── */
  var overlay, stepsContainer, resultContainer, progressDots;
  var nextBtn, backBtn, navContainer, progressContainer;
  var titleEl, subtitleEl;

  /* ── Initialize ── */
  function init() {
    config = loadConfig();

    overlay = document.getElementById('pqOverlay');
    stepsContainer = document.getElementById('pqSteps');
    resultContainer = document.getElementById('pqResult');
    nextBtn = document.getElementById('pqNext');
    backBtn = document.getElementById('pqBack');
    navContainer = document.getElementById('pqNav');
    titleEl = document.getElementById('pqTitle');
    subtitleEl = document.getElementById('pqSubtitle');
    progressContainer = document.getElementById('pqProgress');

    if (!overlay) return;

    /* Set quiz title/subtitle from config */
    if (titleEl) titleEl.textContent = config.quizTitle || DEFAULT_CONFIG.quizTitle;
    if (subtitleEl) subtitleEl.textContent = config.quizSubtitle || DEFAULT_CONFIG.quizSubtitle;

    /* Build progress dots dynamically */
    buildProgressDots();

    /* Close button */
    var closeBtn = document.getElementById('pqClose');
    if (closeBtn) closeBtn.addEventListener('click', closeQuiz);

    /* Overlay click */
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeQuiz();
    });

    /* Keyboard: Escape */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('pq-overlay--active')) {
        closeQuiz();
      }
    });

    /* Navigation */
    if (nextBtn) nextBtn.addEventListener('click', goNext);
    if (backBtn) backBtn.addEventListener('click', goBack);

    /* Restart */
    var restartBtn = document.getElementById('pqRestart');
    if (restartBtn) restartBtn.addEventListener('click', restartQuiz);

    /* Build quiz */
    buildSteps();
    showStep(0);
  }

  /* ── Build Progress Dots ── */
  function buildProgressDots() {
    if (!progressContainer) return;
    progressContainer.innerHTML = '';
    var stepCount = config.steps ? config.steps.length : 4;
    for (var i = 0; i < stepCount; i++) {
      var dot = document.createElement('div');
      dot.className = 'pq-progress__dot';
      progressContainer.appendChild(dot);
    }
    progressDots = progressContainer.querySelectorAll('.pq-progress__dot');
  }

  /* ── Build Steps ── */
  function buildSteps() {
    stepsContainer.innerHTML = '';
    var steps = config.steps || [];

    steps.forEach(function (step, idx) {
      var stepEl = document.createElement('div');
      stepEl.className = 'pq-step';
      stepEl.dataset.step = idx;

      var question = document.createElement('h3');
      question.className = 'pq-question';
      question.textContent = step.question;
      stepEl.appendChild(question);

      var optionsGrid = document.createElement('div');
      var optCount = step.options ? step.options.length : 0;
      var useThreeCol = step.threeCol || optCount === 3;
      optionsGrid.className = 'pq-options' + (useThreeCol ? ' pq-options--three' : '');

      if (step.options) {
        step.options.forEach(function (opt, optIdx) {
          var optionEl = document.createElement('button');
          optionEl.type = 'button';
          optionEl.className = 'pq-option';
          optionEl.dataset.step = idx;
          optionEl.dataset.optIdx = optIdx;
          optionEl.setAttribute('aria-label', opt.label);

          optionEl.innerHTML =
            '<span class="pq-option__emoji">' + (opt.emoji || '•') + '</span>' +
            '<span class="pq-option__label">' + (opt.label || '') + '</span>';

          optionEl.addEventListener('click', function () {
            selectOption(idx, optIdx, optionEl);
          });

          optionsGrid.appendChild(optionEl);
        });
      }

      stepEl.appendChild(optionsGrid);
      stepsContainer.appendChild(stepEl);
    });
  }

  /* ── Select Option ── */
  function selectOption(stepIdx, optIdx, el) {
    answers[stepIdx] = optIdx;
    selectedOptions[stepIdx] = config.steps[stepIdx].options[optIdx];

    /* Visual selection */
    var siblings = el.parentElement.querySelectorAll('.pq-option');
    siblings.forEach(function (s) { s.classList.remove('pq-option--selected'); });
    el.classList.add('pq-option--selected');

    if (nextBtn) nextBtn.disabled = false;

    /* Auto-advance */
    setTimeout(function () {
      if (currentStep < config.steps.length - 1) {
        goNext();
      } else {
        showResult();
      }
    }, 300);
  }

  /* ── Show Step ── */
  function showStep(idx) {
    currentStep = idx;

    var allSteps = stepsContainer.querySelectorAll('.pq-step');
    allSteps.forEach(function (s) { s.classList.remove('pq-step--active'); });

    var targetStep = stepsContainer.querySelector('[data-step="' + idx + '"]');
    if (targetStep) targetStep.classList.add('pq-step--active');

    /* Progress dots */
    if (progressDots) {
      progressDots.forEach(function (dot, i) {
        dot.classList.remove('pq-progress__dot--active', 'pq-progress__dot--done');
        if (i === idx) dot.classList.add('pq-progress__dot--active');
        else if (i < idx) dot.classList.add('pq-progress__dot--done');
      });
    }

    /* Nav */
    if (backBtn) backBtn.style.visibility = idx === 0 ? 'hidden' : 'visible';
    if (nextBtn) {
      nextBtn.disabled = answers[idx] === undefined;
      nextBtn.textContent = idx === config.steps.length - 1 ? 'See Results' : 'Next';
    }

    /* Show steps, hide result */
    resultContainer.classList.remove('pq-result--active');
    stepsContainer.style.display = '';
    navContainer.style.display = '';
  }

  /* ── Navigation ── */
  function goNext() {
    if (answers[currentStep] === undefined) return;
    if (currentStep < config.steps.length - 1) {
      showStep(currentStep + 1);
    } else {
      showResult();
    }
  }

  function goBack() {
    if (currentStep > 0) showStep(currentStep - 1);
  }

  /* ── Show Result ── */
  function showResult() {
    stepsContainer.style.display = 'none';
    navContainer.style.display = 'none';

    /* Step 1: audience */
    var step1Opt = selectedOptions[0] || {};
    var audience = step1Opt.value || 'self';

    /* Step 2: collection */
    var step2Opt = selectedOptions[1] || {};
    var collectionHandle = step2Opt.collection || 'all';
    var collectionLabel = step2Opt.collectionTitle || step2Opt.label || 'All Jewellery';
    var resultEmoji = step2Opt.resultEmoji || step2Opt.emoji || '💎';

    /* Step 3: style tag */
    var step3Opt = selectedOptions[2] || {};
    var styleTag = step3Opt.tag || '';

    /* Step 4: budget */
    var step4Opt = selectedOptions[3] || {};
    var sortOrder = step4Opt.sort || 'none';
    var minPrice = step4Opt.minPrice || 0;
    var maxPrice = step4Opt.maxPrice || 0;

    /* Build URL. Prefix with Shopify's locale-aware root (e.g. "/" or "/fr/") so the
       link keeps the market/locale path under Shopify Markets instead of dropping it. */
    var localeRoot = (window.Shopify && Shopify.routes && Shopify.routes.root)
      ? Shopify.routes.root.replace(/\/$/, '')
      : '';
    var url = localeRoot + '/collections/' + collectionHandle;

    /* Tags */
    var tags = [];
    if (styleTag) tags.push(styleTag);
    if (audience === 'gift') tags.push('gift');
    if (tags.length > 0) url += '/' + tags.join('+');

    /* Query params: price filter + sort */
    var params = [];
    if (minPrice > 0) params.push('filter.v.price.gte=' + minPrice);
    if (maxPrice > 0) params.push('filter.v.price.lte=' + maxPrice);
    if (sortOrder && sortOrder !== 'none') params.push('sort_by=' + sortOrder);
    if (params.length > 0) url += '?' + params.join('&');

    /* Result message */
    var message = audience === 'gift'
      ? (config.resultMessageGift || DEFAULT_CONFIG.resultMessageGift)
      : (config.resultMessageSelf || DEFAULT_CONFIG.resultMessageSelf);

    /* Update DOM */
    var emojiEl = document.getElementById('pqResultEmoji');
    var headingEl = document.getElementById('pqResultHeading');
    var descEl = document.getElementById('pqResultDesc');
    var ctaEl = document.getElementById('pqResultCta');

    if (emojiEl) emojiEl.textContent = resultEmoji;
    if (headingEl) headingEl.textContent = 'We recommend: ' + collectionLabel;
    if (descEl) descEl.textContent = message;
    if (ctaEl) ctaEl.href = url;

    /* All progress dots done */
    if (progressDots) {
      progressDots.forEach(function (dot) {
        dot.classList.remove('pq-progress__dot--active');
        dot.classList.add('pq-progress__dot--done');
      });
    }

    resultContainer.classList.add('pq-result--active');
  }

  /* ── Open / Close ── */
  function closeQuiz() {
    overlay.classList.remove('pq-overlay--active');
    document.body.classList.remove('pq-quiz-open');
    document.body.style.overflow = '';
  }

  function restartQuiz() {
    answers = {};
    selectedOptions = {};
    currentStep = 0;

    var allOptions = stepsContainer.querySelectorAll('.pq-option');
    allOptions.forEach(function (o) { o.classList.remove('pq-option--selected'); });

    showStep(0);
  }

  /* ── Boot ── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
